import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css'
import {BrowserRouter as Router,Redirect,Route,Switch} from 'react-router-dom'
import { Course, Guide, Home, LandingForum, Login, Register, Shopping, UserPanel } from './Pages/Index';
import ConfirmCode from './Pages/Auth/ConfirmCode/ConfirmCode';
import { ToastContainer } from 'react-toastify';
import Category from './Pages/Forum/Category/Category';
import Question from './Pages/Forum/Question/Question';
import { getPageApi } from './Api/ClientServices';
import CustomePage from './Pages/CustomePage/CustomePage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
function App() {
  const[pageList,setPageList]=useState([])
  useEffect(()=>{
    getPageList()
  },[])
  const getPageList=async()=>{
    const data=await getPageApi('all')
    setPageList(data.pages)
  }




  const isLogin =()=>!!localStorage.getItem("clientElectronicToken")


  const PublicRoute =({component,...props})=>{
    return <Route {...props} render={(props)=>{
        if(isLogin())
            return <Redirect to="/"/>
        else{
            return React.createElement(component)
        }    
    }}/>
}

const PrivatRoute=({render,...props})=>{
    return <Route {...props} render={(props)=>{
          if(isLogin())
              return render(props);
              
          else{
              return <Redirect to="/login"/>
          }    
      }}/>
  }
  const routeComponents = pageList.map((item,index) => <Route exact path={`/${item.page}`} component={CustomePage} key={index} />);
  return (
    <Router>
    <Switch>
    <PublicRoute exact path="/login" component={Login}/>
    <Route exact path="/confirm" component={ConfirmCode}/>
    <Route exact path="/register" component={Register}/>
    {
      routeComponents
    }
    <Route exact path='/' component={Home}/>
    <Route exact path='/guide' component={Guide}/>
    <PrivatRoute path="/" render={()=>
      <Switch>
        <Route exact path='/course/:id' component={Course}/>
        <Route  path='/panel' component={UserPanel}/>
        <Route exact path='/shop' component={Shopping}/>
        <Route exact path='/forum' component={LandingForum}/>
        <Route exact path='/forum/:id' component={Category}/>
        <Route exact path='/forum/question/:id' component={Question}/>
      </Switch> 
    }/>
    </Switch>
    <ToastContainer limit={3}/>
    <a
        href="https://wa.me/989111555313?text=سلام این پیام از سایت گام به گام با الکترونیک هست"
        className={'whatsappSupport'}
        target="_blank"
        rel="noopener noreferrer"
        
      >
        <FontAwesomeIcon icon={faWhatsapp}/>
      </a>
</Router>
  );

}

export default App;
